module.exports = __webpack_public_path__ + "img/JND11X5.png";